import React, { useState, useEffect } from "react";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import moment from "moment";

const TIMEZONE_MAPPING = {
  "UTC": "UTC",
  "Etc/GMT+12": "United States (Baker Island)",
  "Etc/GMT+11": "American Samoa",
  "Etc/GMT+10": "French Polynesia",
  "Etc/GMT+9": "China",
  "Etc/GMT+8": "Canada (Vancouver, BC)",  // Pacific Time
  "Etc/GMT+7": "Thailand",
  "Etc/GMT+6": "Mexico",
  "Etc/GMT+5": "Colombia",
  "Etc/GMT+4": "Dominican Republic",
  "Etc/GMT+3": "Brazil",
  "Etc/GMT+2": "Brazil (Fernando de Noronha)",
  "Etc/GMT+1": "Portugal (Azores)",
  "Etc/GMT": "United Kingdom",
  "Etc/GMT-1": "Spain",
  "Etc/GMT-2": "Greece",
  "Etc/GMT-3": "Russia (Moscow)",
  "Etc/GMT-4": "United Arab Emirates",
  "Etc/GMT-5": "Uzbekistan",
  "Etc/GMT-5:30": "India",
  "Etc/GMT-6": "Bangladesh",
  "Etc/GMT-7": "Thailand",
  "Etc/GMT-8": "China",
  "Etc/GMT-9": "Japan",
  "Etc/GMT-10": "Australia",
  "Etc/GMT-11": "Solomon Islands",
  "Etc/GMT-12": "New Zealand",
  "Etc/GMT-13": "Tonga",
  "Etc/GMT-14": "Kiribati",
  "America/New_York": "United States (New York)",
  "America/Los_Angeles": "Canada (Vancouver, BC)",  // Pacific Time
  "America/Denver": "Canada (Calgary, AB)",  // Mountain Time
  "America/Chicago": "Canada (Winnipeg, MB)",  // Central Time
  "America/Toronto": "Canada (Toronto, ON)",  // Eastern Time
  "America/Halifax": "Canada (Halifax, NS)",  // Atlantic Time
  "America/St_Johns": "Canada (St. John's, NFLD)",  // Newfoundland Time
  "Europe/London": "United Kingdom",
  "Europe/Paris": "France",
  "Asia/Dubai": "United Arab Emirates",
};


const TimezoneSelector = ({ userTimezone, onTimezoneChange }) => {
  const [selectedTimezone, setSelectedTimezone] = useState(userTimezone || Intl.DateTimeFormat().resolvedOptions().timeZone);

 

  const getTimezonesWithOffsets = () => {
    const timezoneGroups = {};

    Object.entries(TIMEZONE_MAPPING).forEach(([tz, city]) => {
      try {
        const date = new Date();
        const offsetMinutes = date.getTimezoneOffset() - new Date(date.toLocaleString("en-US", { timeZone: tz })).getTimezoneOffset();
        const offsetHours = offsetMinutes / 60;
        const offsetFormatted = offsetHours >= 0 ? `+${offsetHours}` : `${offsetHours}`;
        const formattedOffset = `(GMT${offsetFormatted})`;

        if (!timezoneGroups[formattedOffset]) {
          timezoneGroups[formattedOffset] = [];
        }
        timezoneGroups[formattedOffset].push({ city, tz });
      } catch (error) {
        console.error(`Error processing timezone ${tz}:`, error);
      }
    });

    return timezoneGroups;
  };

  const handleTimezoneChange = (event) => {
    setSelectedTimezone(event.target.value);
    onTimezoneChange(event.target.value);
  };

  const formatTimezoneLabel = ({ tz, city }) => {
    try {
      const offsetMatch = new Date().toLocaleString("en-US", { timeZone: tz, timeZoneName: "short" }).match(/GMT([+-]?\d+)/);
      const offsetFormatted = offsetMatch ? `(GMT${offsetMatch[1]})` : "(UTC)";
      return `${offsetFormatted} ${city}`;
    } catch (error) {
      console.error(`Error formatting timezone ${tz}:`, error);
      return tz;
    }
  };

  const timezoneGroups = getTimezonesWithOffsets();

  return (
    <FormControl fullWidth>
      <InputLabel id="timezone-select-label">Timezone</InputLabel>
      <Select
        labelId="timezone-select-label"
        id="timezone-select"
        value={selectedTimezone}
        label="Timezone"
        onChange={handleTimezoneChange}
        MenuProps={{ PaperProps: { style: { maxHeight: 300, overflow: 'auto' } } }}
      >
        {Object.entries(timezoneGroups)
          .sort((a, b) => a[0].localeCompare(b[0]))
          .flatMap(([groupName, cities]) => cities.map(({ tz, city }) => (
            <MenuItem key={tz} value={tz}>
              {formatTimezoneLabel({ tz, city })}
            </MenuItem>
          )))}
      </Select>
    </FormControl>
  );
};

export default TimezoneSelector;